// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vbbiJD {
  font-size: var(--type-subtitle-md-font-size);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  margin-bottom: 0;
}

.GuLh5f {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 0;
}

.Wruh8f {
  display: flex;
}

.xYIBvn {
  background-color: var(--surface-neutral-pale, #fafafa);
  border: 1px solid var(--stroke-neutral-silver, #cccccc);
  border-radius: var(--radius-s, 4px);
  display: flex;
  gap: var(--spacing-1-5);
  width: 100%;
}

.HNjmJA {
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.taWnvc {
  padding: var(--spacing-1-5);
  padding-right: 20px;
  border: none;
  background: transparent;
  font-size: var(--font-size-md, 14px);
  color: var(--primary-orange-500, #d64000);
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.T2gRpF {
  position: absolute;
  right: 0;
  pointer-events: none;
  color: var(--primary-orange-500, #d64000);
  width: var(--spacing-2, 16px);
  height: var(--spacing-2, 16px);
}

.taWnvc:focus {
  outline: none;
}

.WNpBon {
  width: 1px;
  height: 24px;
  background-color: var(--stroke-neutral-silver, #cccccc);
  margin: var(--spacing-1-5) 0;
}

._ORNY1 {
  flex: 1;
}

.TBj7Kn {
  border: none;
}

.TBj7Kn:not(.h2QQMu):not(.gT3fHx):hover {
  background-color: transparent;
}

.pUFhhc {
  flex: 1;
  font-weight: var(--font-weight-semibold);
  min-height: var(--spacing-6);
  padding-right: var(--spacing-1-5, 12px);
  color: var(--text-neutral-dark);
  background-color: transparent;
  border: none;
  text-align: right;
  outline: 0;
}

._kf1JS {
  display: flex;
  align-items: center;
}

.jncb5R {
  white-space: nowrap;
}

.jPab1g {
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--spacing-2);
  padding-left: var(--spacing-2);
  align-items: center;
}

.BNQaMh {
  max-width: 300px;
  width: 160px;
}

.Gsr4bk {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 36px;
  background-color: var(--surface-neutral-pale);
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-s);
  overflow: hidden;
}

.VjUmhO {
  position: absolute;
  left: var(--spacing-1-5);
  z-index: 1;
  color: var(--text-neutral-medium, #666666);
}

.VjUmhO img {
  filter: none !important;
}

.pGsiq8 {
  flex: 1;
  height: 100%;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px) var(--spacing-1, 8px) 36px;
  border: none;
  background: transparent;
  font-size: var(--font-size-sm, 12px);
  color: var(--text-neutral-stronger, #374151);
  outline: none;
  width: 100%;
}

.pGsiq8::placeholder {
  color: var(--text-neutral-medium, #999999);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/ParametersPage/components/ParametersStep2/ParametersStep2.module.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sDAAsD;EACtD,uDAAuD;EACvD,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,yCAAyC;EACzC,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,yCAAyC;EACzC,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uDAAuD;EACvD,4BAA4B;AAC9B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,wCAAwC;EACxC,4BAA4B;EAC5B,uCAAuC;EACvC,+BAA+B;EAC/B,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,8CAA8C;EAC9C,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kFAAkF;EAClF,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,4CAA4C;EAC5C,aAAa;EACb,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":[".sectionTitle {\n  font-size: var(--type-subtitle-md-font-size);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  margin-bottom: 0;\n}\n\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  min-height: 0;\n}\n\n.releaseConfigContainer {\n  display: flex;\n}\n\n.releaseTypeAndValueContainer {\n  background-color: var(--surface-neutral-pale, #fafafa);\n  border: 1px solid var(--stroke-neutral-silver, #cccccc);\n  border-radius: var(--radius-s, 4px);\n  display: flex;\n  gap: var(--spacing-1-5);\n  width: 100%;\n}\n\n.dropdownContainer {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  position: relative;\n}\n\n.releaseTypeDropdown {\n  padding: var(--spacing-1-5);\n  padding-right: 20px;\n  border: none;\n  background: transparent;\n  font-size: var(--font-size-md, 14px);\n  color: var(--primary-orange-500, #d64000);\n  cursor: pointer;\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.dropdownIcon {\n  position: absolute;\n  right: 0;\n  pointer-events: none;\n  color: var(--primary-orange-500, #d64000);\n  width: var(--spacing-2, 16px);\n  height: var(--spacing-2, 16px);\n}\n\n.releaseTypeDropdown:focus {\n  outline: none;\n}\n\n.divider {\n  width: 1px;\n  height: 24px;\n  background-color: var(--stroke-neutral-silver, #cccccc);\n  margin: var(--spacing-1-5) 0;\n}\n\n.valueContainer {\n  flex: 1;\n}\n\n.valueInputContainer {\n  border: none;\n}\n\n.valueInputContainer:not(.disabled):not(.readonly):hover {\n  background-color: transparent;\n}\n\n.valueInput {\n  flex: 1;\n  font-weight: var(--font-weight-semibold);\n  min-height: var(--spacing-6);\n  padding-right: var(--spacing-1-5, 12px);\n  color: var(--text-neutral-dark);\n  background-color: transparent;\n  border: none;\n  text-align: right;\n  outline: 0;\n}\n\n.monthlyValueContainer {\n  display: flex;\n  align-items: center;\n}\n\n.monthlyApplyValueButton {\n  white-space: nowrap;\n}\n\n.beneficiariesHeader {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: var(--spacing-2);\n  padding-left: var(--spacing-2);\n  align-items: center;\n}\n\n.searchContainer {\n  max-width: 300px;\n  width: 160px;\n}\n\n.searchField {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-height: 36px;\n  background-color: var(--surface-neutral-pale);\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-s);\n  overflow: hidden;\n}\n\n.searchIcon {\n  position: absolute;\n  left: var(--spacing-1-5);\n  z-index: 1;\n  color: var(--text-neutral-medium, #666666);\n}\n\n.searchIcon img {\n  filter: none !important;\n}\n\n.searchInput {\n  flex: 1;\n  height: 100%;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px) var(--spacing-1, 8px) 36px;\n  border: none;\n  background: transparent;\n  font-size: var(--font-size-sm, 12px);\n  color: var(--text-neutral-stronger, #374151);\n  outline: none;\n  width: 100%;\n}\n\n.searchInput::placeholder {\n  color: var(--text-neutral-medium, #999999);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionTitle": `vbbiJD`,
	"loadingContainer": `GuLh5f`,
	"releaseConfigContainer": `Wruh8f`,
	"releaseTypeAndValueContainer": `xYIBvn`,
	"dropdownContainer": `HNjmJA`,
	"releaseTypeDropdown": `taWnvc`,
	"dropdownIcon": `T2gRpF`,
	"divider": `WNpBon`,
	"valueContainer": `_ORNY1`,
	"valueInputContainer": `TBj7Kn`,
	"disabled": `h2QQMu`,
	"readonly": `gT3fHx`,
	"valueInput": `pUFhhc`,
	"monthlyValueContainer": `_kf1JS`,
	"monthlyApplyValueButton": `jncb5R`,
	"beneficiariesHeader": `jPab1g`,
	"searchContainer": `BNQaMh`,
	"searchField": `Gsr4bk`,
	"searchIcon": `VjUmhO`,
	"searchInput": `pGsiq8`
};
module.exports = ___CSS_LOADER_EXPORT___;
